import React from 'react';
import { Popover } from '@firesoon/antd';
import { Button } from '@firesoon/antd';
import { NoticeFill } from '@firesoon/icons-react';
import { Iprops } from './interface';
import './index.less';

export default ({ children, type, onCancel, onOk, ...rest }: Iprops) => {
  if (type) {
    const isOperate = type === 'operate';
    return (
      <Popover
        {...rest}
        trigger="click"
        overlayClassName={`fs-popover-operate-wrapper fs-popover-${type}-wrapper`}
        title={
          <>
            <NoticeFill className="fs-popver-icon" style={{ fontSize: 12 }} />
            <div className="fs-popver-content">{rest?.title}</div>
          </>
        }
        content={
          <div className="fs-popover-content">
            <Button type="default" size="small" onClick={onCancel}>
              取消
            </Button>
            <Button type={isOperate ? 'primary' : 'danger'} size="small" onClick={onOk}>
              {isOperate ? '确认' : '删除'}
            </Button>
          </div>
        }
      >
        {children}
      </Popover>
    );
  }

  return (
    <Popover {...rest} overlayClassName="fs-popover-wrapper">
      {children}
    </Popover>
  );
};
